// @flow
import React, { Component } from 'react';
import LetterCardList from 'components/common/LetterCardList/LetterCardList';
import type { State } from 'store';
import { LetteringActions } from 'store/actionCreators';
import type { LetterItem } from 'store/modules/lettering';
import { connect } from 'react-redux';
import throttle from 'lodash/throttle';
import { getScrollBottom, preventStickBottom } from 'lib/common';

type OwnProps = {
  sort: string,
  category: string,
};

type Props = OwnProps & {
  letters: ?(LetterItem[]),
  prefetched: ?(LetterItem[]),
  prefetching: boolean,
  loading: boolean,
  width: number,
  hasEnded: boolean,
  shouldCancel: boolean,
};

class LetteringLetterCards extends Component<Props> {
  prevCursor: ?string = null;

  prefetch = async () => {
    const { letters, prefetching, loading, category, sort } = this.props;
    if (!letters || letters.length === 0 || prefetching || loading) return;
    const lastId = letters[letters.length - 1].id;
    if (this.props.prefetched) {
      LetteringActions.revealPrefetched('recent');
      await Promise.resolve(); // next tick
    }
    if (lastId === this.prevCursor) return;
    this.prevCursor = lastId;
    try {
      await LetteringActions.prefetchRecentLetters(lastId, category, sort);
    } catch (e) {
      console.log(e);
    }
    preventStickBottom();
    this.onScroll();
  };

  onScroll = throttle(() => {
    const scrollBottom = getScrollBottom();
    if (scrollBottom > 1000) return;
    this.prefetch();
  }, 250);

  initialize = async () => {
    const { letters, shouldCancel, category, sort } = this.props;
    try {
      if (letters && letters.length > 0) {
        // do not fetch letter data when already exists
        return;
      }
      if (!shouldCancel) {
        await LetteringActions.getRecentLetters('', category, sort);
      }
      this.prefetch();
    } catch (e) {
      console.log(e);
    }
  };

  listenScroll = () => {
    window.addEventListener('scroll', this.onScroll);
  };

  unlistenScroll = () => {
    window.removeEventListener('scroll', this.onScroll);
  };

  listenSort = async () => {
    const { category, sort } = this.props;
    await LetteringActions.getRecentLetters('', category, sort);
    this.prefetch();
  };

  componentDidMount() {
    this.initialize();
    this.listenScroll();
  }

  componentWillUnmount() {
    this.unlistenScroll();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sort !== this.props.sort) {
      this.listenSort();
    }
  }

  render() {
    return (
      <LetterCardList
        letters={this.props.letters}
        loading={this.props.loading}
        prefetching={
          (this.props.prefetched && this.props.prefetched.length > 0) || this.props.prefetching
        }
        width={this.props.width}
        hasEnded={this.props.hasEnded}
      />
    );
  }
}

const mapStateToProps = ({ lettering, pender, base, common }: State) => ({
  letters: lettering.recent.letters,
  prefetched: lettering.recent.prefetched,
  prefetching: pender.pending['lettering/PREFETCH'],
  loading: pender.pending['lettering/GET_RECENT_POSTS'],
  width: base.windowWidth,
  hasEnded: lettering.recent.end,
  shouldCancel: common.ssr && !common.router.altered,
});

export default connect(mapStateToProps, () => ({}))(LetteringLetterCards);



// WEBPACK FOOTER //
// ./src/containers/list/LetteringLetterCards.js